import AddNewPlant from './AddNewPlant';

export default AddNewPlant;
